import {Divider, Grid} from "@mui/material";
import React from "react";

export default function FormattingDivider(){
    return <Grid item >
        <Divider orientation="vertical" />
    </Grid>
}